export default [
  {
    path: "/7abdb4d2-203e-4bb6-aba5-187d502c677a",
    children: [
      {
        path: "schools",
        name: "schoolsList",
        component: () => import("@/views/school/list.vue"),
        meta: {
          title: "Schools",
          authRequired: true,
          acc: "y43975",
        },
      },
      {
        path: "view-school",
        name: "schoolView",
        component: () => import("@/views/school/view.vue"),
        meta: {
          title: "Schools",
          authRequired: true,
          acc: "y91183",
        },
      },
     
    ],
  },
];
